/* oxlint-disable @typescript-eslint/no-explicit-any */
import { Spinner } from '@latitude/spinner';
import { animated, useTransition } from '@react-spring/web';
import * as React from 'react';

import css from './styles.module.scss';

const FadingTransition = ({
  children,
  data = true,
  className = '',
}: {
  data?: any;
  children: React.ReactNode;
  className?: string;
}) => {
  const transitions = useTransition(data, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { display: 'none' },
  });

  return (
    <React.Suspense fallback={<Spinner className={css.loader} />}>
      {transitions((props) => (
        <animated.div className={className} style={props}>
          {children}
        </animated.div>
      ))}
    </React.Suspense>
  );
};

export default FadingTransition;
